module.exports = __webpack_public_path__ + "static/media/abrindoColetor.904e2dab.jpg";